import { __makeTemplateObject } from './../external/tslib/tslib.es6.js';
import { css } from 'styled-components';

var opacityDisabled = css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  opacity: ", ";\n  cursor: not-allowed;\n"], ["\n  opacity: ", ";\n  cursor: not-allowed;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.olist.opacity.base;
});
var templateObject_1;

export { opacityDisabled };
